<template>
    <div>    
        <b-modal v-model="showIdlePopup" header-text-variant="light" header-bg-variant="dark" body-text-variant="light" body-bg-variant="dark" footer-text-variant="light" footer-bg-variant="dark" 
         :ycentered=true hide-footer title="Inactive Session">
            <div>
                {{ $t('message.inactiveSession', { logoutCountdown: this.logoutCountdown / 1000 })}}        
            </div>
        </b-modal>    
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
export default {
	data() {
		return {
			logoutCountdown: 10000, //automatically logout the user in 10 seconds if no action
            showIdlePopup: false,  
		}
	},
	created() {
        console.info('isAuthenticated', this.isAuthenticated);
        if (this.isAuthenticated) {
            console.info('show idle', new Date()); 
            this.showIdlePopup = true;
            var vm = this;
            let timerId = setInterval(() => {
                vm.logoutCountdown -= 1000;
                if (!vm.$store.state.idleVue.isIdle) clearInterval(timerId);
                if (vm.logoutCountdown < 1) {
                    clearInterval(timerId);
                    vm.showIdlePopup = false;
                    vm.logout();
                }
            }, 1000);
        }
    },
    computed: {
        ...mapState({
        }),
        ...mapGetters({
            isAuthenticated: 'isAuthenticated',   
        }),
    },
    methods: {
        logout() {
            console.info('logged out', new Date());
            this.$store.dispatch("logout");
            this.$router.push('/');
        },
    },
};
</script>